import { useCallback, useEffect, useState } from 'react';
import { consumeOutboundLinkOpened } from '../../../lib/outbound-link';
import { getTrimmedPhoneNumber } from '../../../lib/phone';

// Shows the popup once the visitor is back on the page after leaving for OnlyFans.
export const usePhonePopup = (pageData) => {
  const [isPhonePopupVisible, setIsPhonePopupVisible] = useState(false);

  const phoneNumber = getTrimmedPhoneNumber(pageData.PhonePopupNumber);
  const onlyfansUrl = pageData.Onlyfans;
  const isPhonePopupEnabled = Boolean(
    pageData.PhonePopup && phoneNumber && onlyfansUrl
  );

  useEffect(() => {
    if (typeof window === 'undefined' || !isPhonePopupEnabled) {
      return;
    }

    const showPopupIfReturnedFromOnlyfans = () => {
      if (document.visibilityState !== 'visible') {
        return;
      }

      const lastOutboundLink = consumeOutboundLinkOpened();
      if (lastOutboundLink === onlyfansUrl) {
        setIsPhonePopupVisible(true);
      }
    };

    // `pageshow` covers a full return navigation, `visibilitychange` a tab switch back
    showPopupIfReturnedFromOnlyfans();
    window.addEventListener('pageshow', showPopupIfReturnedFromOnlyfans);
    document.addEventListener(
      'visibilitychange',
      showPopupIfReturnedFromOnlyfans
    );

    return () => {
      window.removeEventListener('pageshow', showPopupIfReturnedFromOnlyfans);
      document.removeEventListener(
        'visibilitychange',
        showPopupIfReturnedFromOnlyfans
      );
    };
  }, [isPhonePopupEnabled, onlyfansUrl]);

  const closePhonePopup = useCallback(() => setIsPhonePopupVisible(false), []);

  return { isPhonePopupVisible, phoneNumber, closePhonePopup };
};
